import { Injectable } from '@angular/core';
import { Adapter } from '@app/core/adapter';
import { CompanyAssetsStats } from '@app/shared/models/company-assets-stats.model';

@Injectable()
export class CompanyAssetsStatsAdapter implements Adapter<CompanyAssetsStats> {
    adapt(data: any): CompanyAssetsStats {
        return {
            greenCount: data.numGreen || 0,
            yellowCount: data.numYellow || 0,
            redCount: data.numRed || 0,
            inactiveCount: data.numInactive || 0,
        } as CompanyAssetsStats;
    }
}
